module.exports = __webpack_public_path__ + "img/prizes-cz.476daae5.png";